export class GetFlag {
    static GetLangInfos(language: string): any {
        const infos = { cssClass: '', name: '' };
        
        if (language) {
            switch(language) {
                case 'gb': // English
                case 'en-US':
                case 'en':
                case 'En':
                case 'en-UK':
                case 'en-EN':
                case 'en-GB':
                    infos.cssClass = 'fi-gb';
                    infos.name = 'English';
                    break;
                case 'nl': // Dutch
                    infos.cssClass = 'fi-nl';
                    infos.name = 'Nederlands';
                    break;
                case 'fr': // French, Breton
                case 'Fr': // Cordial case 
                case 'br-FR':
                    infos.cssClass = 'fi-fr';
                    infos.name = 'Français';
                    break;
                case 'de-DE':
                case "de-AT":
                case "de-CH":
                case 'de': // German
                    infos.cssClass = 'fi-de';
                    infos.name = 'Deutsch';
                    break;
                case 'es': // Spanish, Asturian, Catalan, Galician
                    infos.cssClass = 'fi-es';
                    infos.name = 'Español';
                    break;
                case 'pt': // Portuguese
                case 'pt-PT': // Portuguese
                case 'pt-BR': // Brésilien
                    infos.cssClass = 'fi-pt';
                    infos.name = 'Português';
                    break;
                case 'sa': // Arabic
                case 'ar':
                    infos.cssClass = 'fi-sa';
                    infos.name = 'عربي';
                    break;
                case 'by': // Belarusian
                case 'be-BY':
                    infos.cssClass = 'fi-by';
                    infos.name = 'беларускі';
                    break;
                case 'cn': // Chinese
                case 'zh-CN':
                    infos.cssClass = 'fi-cn';
                    infos.name = '中国人';
                    break;
                case 'dk': // Danish
                case 'da-DK':
                    infos.cssClass = 'fi-dk';
                    infos.name = 'Dansk';
                    break;
                case 'gr': // Greek
                case 'el-GR':
                    infos.cssClass = 'fi-gr';
                    infos.name = 'Ελληνικά';
                    break;
                case 'ie': // Irish
                case 'ga-IE':
                    infos.cssClass = 'fi-ie';
                    infos.name = 'Gaeilge';
                    break;
                case 'it': // Italian
                    infos.cssClass = 'fi-it';
                    infos.name = 'Italiano';
                    break;
                case 'jp': // Japanese
                case 'ja-JP':
                    infos.cssClass = 'fi-jp';
                    infos.name = '日本語';
                    break;
                case 'kh': // Khmer
                case 'km-KH':
                    infos.cssClass = 'fi-kh';
                    infos.name = 'ខ្មែរ';
                    break;
                case 'no': // Norwegian
                    infos.cssClass = 'fi-no';
                    infos.name = 'Norsk';
                    break;
                case 'ir': // Persian
                case 'fa':
                    infos.cssClass = 'fi-ir';
                    infos.name = 'فارسی';
                    break;
                case 'pl': // Polish
                case 'pl-PL':
                    infos.cssClass = 'fi-pl';
                    infos.name = 'Polski';
                    break;
                case 'ro': // Romanian
                case 'ro-RO':
                    infos.cssClass = 'fi-ro';
                    infos.name = 'Română';
                    break;
                case 'ru': // Russian
                case 'ru-RU':
                    infos.cssClass = 'fi-ru';
                    infos.name = 'Русский';
                    break;
                case 'sk': // Slovak
                case 'sk-SK':
                    infos.cssClass = 'fi-sk';
                    infos.name = 'Slovenský';
                    break;
                case 'si': // Slovenian
                case 'sl-SI':
                    infos.cssClass = 'fi-si';
                    infos.name = 'Slovenščina';
                    break;
                case 'se': // Swedish
                case 'sv':
                    infos.cssClass = 'fi-se';
                    infos.name = 'Svenska';
                    break;
                case 'ph': // Tagalog
                case 'tl-PH':
                    infos.cssClass = 'fi-ph';
                    infos.name = 'Tagalog';
                    break;
                case 'in': // Tamil
                case 'ta-IN':
                    infos.cssClass = 'fi-in';
                    infos.name = 'தமிழ்';
                    break;
                case 'ua': // Ukrainian
                case 'uk-UA':
                    infos.cssClass = 'fi-ua';
                    infos.name = 'українська';
                    break;
                default:
                    infos.cssClass = ''; // Default CSS class, or you could set it to a generic flag
                    infos.name = ''; // Default name, or you could set it to a generic flag
            }
        }
        return infos;
    }
}
